import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
import { SEQURA_URL, SEQURA_KEY, SEQURA_MERCHANT_REFERENCE } from '~/const/3rd';
export default {
  name: 'Sequra',
  props: {
    price: {
      type: String,
      required: true
    }
  },
  computed: {
    tracking: function tracking() {
      return {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Display_paiement_sans_frais_es',
          event_label: 'Sequra'
        }
      };
    }
  },
  mounted: function mounted() {
    this.setSequra();
    this.$root.$emit('generic-tracking', null, this.tracking);
  },
  updated: function updated() {
    this.setSequra();
  },
  methods: {
    setSequra: function setSequra() {
      var _this = this;

      // Refer to SeQura documentation for more information:
      // https://docs.sequrapi.com/visual/promotional_components_documentation.html
      if (this.$cookies.get('nothirdparties') || 'nothirdparties' in this.$route.query) {
        return;
      }

      if (window.Sequra && typeof window.Sequra.refreshComponents === 'function') {
        this.$nextTick(function () {
          window.Sequra.refreshComponents();
        });
      } else {
        window.LUX.mark('before Sequra');
        var sequraConfigParams = {
          merchant: SEQURA_MERCHANT_REFERENCE,
          assetKey: SEQURA_KEY,
          products: ['pp3'],
          scriptUri: SEQURA_URL
        };
        window.SequraConfiguration = sequraConfigParams;
        window.SequraOnLoad = [];
        window.Sequra = {};
        this.asyncScript(sequraConfigParams.scriptUri).catch(function (err) {
          console.error('SEQURA FAILED', err);

          if (_this.$sentry) {
            _this.$sentry.captureMessage(err);
          }
        });
      }
    }
  }
};